/* tslint:disable */

declare var Object: any;
export interface InspectionInterface {
  "id"?: string;
  "inspectorId"?: string;
  "pictures"?: any;
  "procedureType"?: string;
  "certificationData"?: any;
  "imageRecognitionData"?: any;
  "inspectionForm"?: any;
  "agentCode"?: string;
  "licencePlate"?: string;
  "clientName"?: string;
  "tipoDoc"?: string;
  "numeroDoc"?: string;
  "vehicleType"?: string;
  "transactionId"?: string;
  "province"?: string;
  "date"?: Date;
}

export class Inspection implements InspectionInterface {
  "id": string;
  "inspectorId": string;
  "pictures": any;
  "procedureType": string;
  "certificationData": any;
  "imageRecognitionData": any;
  "inspectionForm": any;
  "agentCode": string;
  "licencePlate": string;
  "clientName": string;
  "tipoDoc": string;
  "numeroDoc": string;
  "vehicleType": string;
  "transactionId": string;
  "province": string;
  "date": Date;
  constructor(data?: InspectionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Inspection`.
   */
  public static getModelName() {
    return "Inspection";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Inspection for dynamic purposes.
  **/
  public static factory(data: InspectionInterface): Inspection{
    return new Inspection(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Inspection',
      plural: 'Inspections',
      path: 'Inspections',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "inspectorId": {
          name: 'inspectorId',
          type: 'string'
        },
        "pictures": {
          name: 'pictures',
          type: 'any'
        },
        "procedureType": {
          name: 'procedureType',
          type: 'string'
        },
        "certificationData": {
          name: 'certificationData',
          type: 'any'
        },
        "imageRecognitionData": {
          name: 'imageRecognitionData',
          type: 'any'
        },
        "inspectionForm": {
          name: 'inspectionForm',
          type: 'any'
        },
        "agentCode": {
          name: 'agentCode',
          type: 'string'
        },
        "licencePlate": {
          name: 'licencePlate',
          type: 'string'
        },
        "clientName": {
          name: 'clientName',
          type: 'string'
        },
        "tipoDoc": {
          name: 'tipoDoc',
          type: 'string'
        },
        "numeroDoc": {
          name: 'numeroDoc',
          type: 'string'
        },
        "vehicleType": {
          name: 'vehicleType',
          type: 'string'
        },
        "transactionId": {
          name: 'transactionId',
          type: 'string'
        },
        "province": {
          name: 'province',
          type: 'string'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
